
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'ActiveOffersSelector',
    props: {
        modelValue: {
            default: [],
            required: true
        },
    },
    computed: {
        mdl: {
            get(){
                return this.modelValue;
            },
            set(v){
                this.$emit('update:modelValue', v);
            }
        }
    },
    data(){
        return {
            options: [],
            showArchive: false
        };
    },
    async mounted() {
        this.options = [
            { id: 'active', name: "Active" },
            { id: 'inactive', name: "Inactive" },
            { id:'all', name: 'All' },
        ];
    }
});
